import containerFuild from '../html-snippets/container-fuild.js';
import css from '../tpl-css/style-section-cefloreco-benefis.js';

const html = `
<div
  data-use-custom-width="true"
  data-custom-width="1204"
  class="container"
  data-attribute="container-content"
  style="--custom-width: 1204px;"
>
  <div class="layout-section">
    <div
      class="media-content"
      data-attribute="media-content"
      data-order-media="1"
      data-bg-media-title="#1099dc"
      style="--order-media: 1; --bg-media-title: #1099dc"
    >
      <img
        data-attribute="media-image"
        src="https://cdn.skyfastimg.com/images/2026/10/27/image-6ae04985bbec5255e249ffed.webp?w=1000&q=100"
        alt=""
      />
      <div class="media-title" data-attribute="media-title">
        <p>IDEA TO</p>
        <h3>IMPACT</h3>
      </div>
    </div>
    <div class="text-content" data-attribute="text-content" data-order-text="2" style="--order-text: 2">
      <div class="title-content" data-attribute="title-content">
        <p style="color: #ff7657">What we do</p>
        <h2>One team. Every part of the product.</h2>
        <p>
          We move from insight to launch with one connected team—keeping the experience focused and the decisions fast.
        </p>
      </div>
      <div
        class="list-benefit"
        data-attribute="list-benefit"
        data-color-highlight-item="#ff7657"
        style="--color-highlight-item: #ff7657"
      >
        <div class="item-benefit" data-attribute="item-benefit">
          <div class="index-number" data-attribute="index-number">01</div>
          <div class="content-benefit" data-attribute="content-benefit">
            <h3>Product strategy</h3>
            <p>Audience insight, positioning and a clear path to value.</p>
          </div>
        </div>
        <div class="item-benefit" data-attribute="item-benefit">
          <div class="index-number" data-attribute="index-number">01</div>
          <div class="content-benefit" data-attribute="content-benefit">
            <h3>Product strategy</h3>
            <p>Audience insight, positioning and a clear path to value.</p>
          </div>
        </div>
        <div class="item-benefit" data-attribute="item-benefit">
          <div class="index-number" data-attribute="index-number">01</div>
          <div class="content-benefit" data-attribute="content-benefit">
            <h3>Product strategy</h3>
            <p>Audience insight, positioning and a clear path to value.</p>
          </div>
        </div>
        <div class="item-benefit" data-attribute="item-benefit">
          <div class="index-number" data-attribute="index-number">01</div>
          <div class="content-benefit" data-attribute="content-benefit">
            <h3>Product strategy</h3>
            <p>Audience insight, positioning and a clear path to value.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;

export default containerFuild(html, css, {
  topPadding: true,
  bottomPadding: true,
});
